import {ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {greenColors, orangeColors, neutral} from '../../../../../../../layouts/theme/designSystem';

interface Props {
  title: string;
  icon: ReactNode;
  message: string;
}

export const SurveyStatisticOmittedSection = ({title, icon, message}: Props) => (
  <Box>
    <Typography
      sx={{
        alignItems: 'center',
        color: greenColors[700],
        display: 'flex',
        fontSize: '11px',
        fontWeight: 700,
        gap: '5px',
        letterSpacing: '0.04em',
        lineHeight: 1.4,
        marginBottom: '8px',
        textTransform: 'uppercase',
      }}
    >
      {icon}
      {title}
    </Typography>
    <Box
      sx={{
        backgroundColor: orangeColors[7],
        borderRadius: '8px',
        padding: '1rem',
      }}
    >
      <Typography
        sx={{
          color: neutral[500],
          fontSize: '13px',
          lineHeight: 1.4,
        }}
      >
        {message}
      </Typography>
    </Box>
  </Box>
);
